import { identity, contains, isEmpty, isEqual } from 'underscore';
import { mapBulkUpsertErrors } from './map-bulk-upsert-errors';

export const ERROR_ENTITY = {
  Campaign: 'campaign',
  AdGroup: 'adGroup',
  Keyword: 'keyword',
  ResponsiveAd: 'ResponsiveAd',
  ResponsiveSearchAd: 'ResponsiveSearchAd',
  DynamicSearchAd: 'DynamicSearchAd',
  CampaignConversionGoal: 'campaignConversionGoal',
  CampaignDayTimeCriterion: 'campaignDayTimeCriterion',
  AdGroupDayTimeCriterion: 'adGroupDayTimeCriterion',
  CampaignDeviceOSCriterion: 'campaignDeviceOSCriterion',
  AdGroupDeviceOSCriterion: 'adGroupDeviceOSCriterion',
  CampaignDisclaimerAdExtension: 'Campaign Disclaimer Ad Extension Error',
  CampaignGenderCriterion: 'campaignGenderCriterion',
  AdGroupGenderCriterion: 'adGroupGenderCriterion',
  CampaignAgeCriterion: 'campaignAgeCriterion',
  AdGroupAgeCriterion: 'adGroupAgeCriterion',
  CampaignCompanyNameCriterion: 'campaignCompanyNameCriterion',
  AdGroupCompanyNameCriterion: 'adGroupCompanyNameCriterion',
  CampaignIndustryCriterion: 'campaignIndustryCriterion',
  AdGroupIndustryCriterion: 'adGroupIndustryCriterion',
  CampaignJobFunctionCriterion: 'campaignJobFunctionCriterion',
  AdGroupJobFunctionCriterion: 'adGroupJobFunctionCriterion',
  AdGroupDynamicSearchAdTargetError: 'Ad Group Dynamic Search Ad Target Error',
  BrandListAssociation: 'brandListAssociation',
  CampaignLocation: 'campaignLocation',
  CampaignRadius: 'campaignRadius',
  CampaignNegativeLocation: 'campaignNegativeLocation',
  CampaignLocationIntent: 'campaignLocationIntent',
  AdGroupLocation: 'adGroupLocation',
  AdGroupRadius: 'adGroupRadius',
  AdGroupNegativeLocation: 'adGroupNegativeLocation',
  AdGroupLocationIntent: 'adGroupLocationIntent',
};

export const serverErrorsCompare = (prev, curr) => !(!isEmpty(curr) && !isEqual(prev, curr));

const getBulkUploadEntityType = entitySchema =>
  (entitySchema.properties['bulk-upload-type'] || {}).value ||
  entitySchema.name;

export const getBulkUploadErrorType = entitySchema =>
  `${getBulkUploadEntityType(entitySchema)} Error`;

export const modelToViewModelForBulkErrors = (errors, bulkUpsertEntityErrorMap, scenario, i18n, activityLogger, errorProcessor = identity) =>
  mapBulkUpsertErrors(errors, bulkUpsertEntityErrorMap, errorProcessor, scenario, i18n, activityLogger);

const ReferencedEntityInvalidIdErrors = ['CampaignServiceInvalidCampaignId', 'CampaignServiceFutureFeatureCode', 'CampaignServiceInvalidAdGroupId'];
export const removeReferencedEntityInvalidIdErrors = bulkErrors =>
  bulkErrors.filter(({ Error }) => !contains(ReferencedEntityInvalidIdErrors, Error));

export const getPanelErrorProps = ({ needsAttention }) => (needsAttention ? {
  error: _TL_("* Something's wrong"),
} : {});
